export default __webpack_public_path__ + "static/media/md-card-bg-AWS-Cloud-Practitioner.0284756b.png";